import customerAppraiserExclusions from "apis/customerAppraiserExclusions";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";

export const addAppraiserExclusion = (customerNumber, comments, appraiserNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: {
    customerNumber,
    appraiserNumber,
    comments
  },
  endpoint: customerAppraiserExclusions.add(),
  successCallback,
  mountedRef
});

export const removeAppraiserExclusion = (exclusionId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: customerAppraiserExclusions.remove(exclusionId),
  successCallback,
  mountedRef
});

export const getAppraiserExcludedCustomers = (appraiserNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: customerAppraiserExclusions.getCustomers(appraiserNumber),
  successCallback,
  mountedRef
});

export const getExcludedAppraisers = (customerNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: customerAppraiserExclusions.getAppraisers(customerNumber),
  successCallback,
  mountedRef
});